<template>
  <div class="container">
    <div class="login_form">
        <p>2ndTool管理画面ログイン</p>
        <div class="input_form">
        <label>ID</label>
        <input type="text" v-model="email"/>
        </div>
        <div class="input_form">
        <label>パスワード</label>
        <input type="password" v-model="password"/>
        </div>

        <input class="button" type="button" @click="auth" value="ログイン"/>
        <!-- エラーモーダル -->
        <modal :name="errorModalName">
            <div class="modal-header">
                エラー
            </div>
            <div class="modal-body">
            <p>{{ msg }}</p>
            <button type="button" class="btn btn-secondary" @click="$modal.hide(errorModalName)">閉じる</button>
        </div>  
        </modal>
    </div>
  </div>
</template>

<script>
    export default {
        data() {
            return {
                email: '',
                password: '',
                errorModalName: 'error_modal',
                msg: '',
                user: {}
            }
        },
        methods: {
            auth() {
                this.$axios.get('/auth/email/' + this.email + '/password/' + this.password)
                    .then(res => {
                        // メッセージがある場合は表示のみ行う
                        if (res.data.msg) {
                            this.msg = "ログインに失敗しました。IDとパスワードをご確認ください。";
                            this.$modal.show(this.errorModalName);
                            return;
                        }
                        let auth = res.data.auth;
                        if (res.status == 200 && auth) {
                            this.user = this.adjustUser(auth);
                            this.$store.state.user = this.user;
                            this.login();
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        this.msg = "ログインに失敗しました。IDとパスワードをご確認ください。";
                        this.$modal.show(this.errorModalName);                        
                    });
            },
            login() {
                if (this.user.role == 1) {
                    this.$router.push('/admintop');
                } else {
                    this.$router.push('/subadmintop');
                }
            }
        },
        created: function() {
            if (this.$store.state.user.id && this.$store.state.user.id != 0) {
                this.user = this.$store.state.user;
                this.login();
            }
        },
    }
</script>

<style scoped>
    .container {
        width: 100vw;
        height: 100vh;
        background-image: url('/assets/login_bg.jpg');
        background-size: cover;
        position: fixed;
        top: 0;        
    }

    .login_form {
        max-width: 700px;
        height: fit-content;
        padding: 50px 0;
        text-align: center;
        margin: auto;
        margin-top: 200px;
        border: 1px solid white;
        border-radius: 10px;
        box-shadow: 0 0 5px white;  
        background-color: aliceblue;
    }
    
    .login_form p {
        font-size: 30px;
    }
    
    label {
        display: inline-block;
        width: 100px;
        margin-top: 20px;
        text-align: left;
    }
    
    .input_form input {
        background-color: white;
        max-width: 200px;
        height: 30px;
        border: solid 1px #ccc;
        padding: 0 5px;
    }
    
    .button {
        padding: 10px 40px;
        background-color: #1976d2;
        color: white;
        border-radius: 5px;
        margin-top: 20px;
    }
</style>
